import { combineReducers } from 'redux';
import register from './registerReducer';
import login from './authReducer';

const rootReducer = combineReducers({
  register, login
});

export default rootReducer;